module.exports = "/build/images/icons-public.31112a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./html/images/icons-public.svg
// module id = WIg7
// module chunks = 0